/**
 * Doors (interior.ts): over a door or the stairs within reach, what walking on (or E) does there;
 * and through a door, the screen fading out and back in with the floor's name coming up.
 */
import { tag, UI } from '../labels';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'doorHint',
  layer: 'labels',
  order: 200,
  draw({ mg, indoor, world, iso, ox, oy, px }) {
    const hint = indoor.hint(world);
    if (!hint) return;
    const [sx, sy] = iso.proj(hint.x, hint.y);
    mg.textAlign = 'center';
    tag(mg, `▸ ${hint.text}`, (sx + ox) * px, (sy + oy - 26) * px, `600 13px ${UI}`, '#f2d89a');
  },
});

registerRenderPass({
  id: 'doorFade',
  layer: 'top',
  order: 100,
  draw({ mg, indoor, world, dt, screenW, screenH }) {
    indoor.drawScreen(mg, world.interiors.busy, dt, screenW, screenH, `600 22px ${UI}`);
  },
});
